import * as types from "./mutation_type"

const mutations = {
  [types.INIT_TREE](state, tree_data) {
    state.origin_tree = tree_data
  },
  [types.GET_VERSION_LIST](state, version_list) {
    state.version_list = version_list
  },
  [types.GET_INIT_VERSION_NAME](state, name) {
    state.init_version_name = name
  },
  [types.SET_OPERATE_LIST](state, list) {
    state.operate_list = list
  },
  [types.SET_OPERATEUSERNAME](state, name) {
    state.operateUserName = name
  },
};
export default mutations



// WEBPACK FOOTER //
// ./src/store/mutation.js